import { Sidebar } from 'ogp/components/views/sidebar';
import { Outlet } from 'react-router-dom';
import { SidebarProvider } from 'shared/contexts/sidebar-provider';
import { Wrapper } from './helpers';

const BaseLayout = () => {
  return (
    <>
      <SidebarProvider>
        <Sidebar />
      </SidebarProvider>
      <Wrapper>
        <Outlet />
      </Wrapper>
    </>
  );
};

export { BaseLayout };
